<template>
  <div class="upc-item">
    <span>{{ item }}</span>
    <button
      type="button"
      class="item-remove"
      @click="deleteItem()"
    >
      <fa icon="times"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchItem",

  props: {
    item: {
      type: String,
      required: true
    }
  },

  methods: {
    deleteItem() {
      this.$emit('deleteItem')
    }
  }
}
</script>

<style scoped lang="scss">
  .upc-item {
    border: 1px solid #a3a3a3;
    padding: 10px 25px;
    position: relative;
    text-align: left;
    width: 160px;
    margin: calc(60px / 8);

    .item-remove {
      position: absolute;
      top: 5px;
      right: 6px;
      background: transparent;
      border: none;
      padding: 0;
      color: #a3a3a3;
      cursor: pointer;
    }

    &:nth-of-type(5n + 1) {
      margin-left: 0;
    }

    &:nth-of-type(5n) {
      margin-right: 0;
    }
  }
</style>
